$(document)
  .on('ajax:beforeSend', '.js-resend-sms', function ajaxBeforeSendOnResendSms() {
    this.classList.add('js-disabled');
  });
